<template>
  <v-app v-show="loaded">
    <div v-if="isSurveyOnly"></div>
    <div id="chat-view" v-else-if="widgetData && widgetData.config">
      <div class="minimizable-web-chat">
        <div
          v-show="!minimized"
          ref="cb"
          :class="side === 'left' ? 'chat-box left' : 'chat-box right'"
        >
          <header :style="{ display: getHeaderDispaly }" ref="checkBoxHeader">
            <div class="filler"></div>

            <v-tooltip
              location="bottom"
              :text="
                mainView.switchBtnLabel
                  ? mainView.switchBtnLabel
                  : 'Switch Chat side'
              "
            >
              <template v-slot:activator="{ props }">
                <button
                  @mouseover="isShowTooltipOnHover ? props : ''"
                  class="switch"
                  @click="onSwitchSide()"
                  v-bind="props"
                  v-if="
                    (!widgetData.config.openAsNewWindow &&
                      !widgetData.config.isKioskMode) ||
                    !isConnect
                  "
                >
                  <v-img
                    class="control-button-image"
                    :src="mainView.switchBtnIconLink"
                  ></v-img>
                </button>
              </template>
            </v-tooltip>
            <!-- 

original code
  
 -->
            <v-tooltip
              location="bottom"
              :text="
                extendedMode
                  ? mainView.exitFullscreenLabel || 'Reduce to normal size'
                  : mainView.fullscreenLabel || 'Extend chat window'
              "
            >
              <template v-slot:activator="{ props }">
                <button
                  v-bind="props"
                  v-if="!widgetData.config.isKioskMode || !isConnect"
                  @mouseover="isShowTooltipOnHover ? props : ''"
                  class="extend"
                  @click="extendView()"
                >
                  <v-img
                    v-if="!extendedMode"
                    class="control-button-image"
                    :src="mainView.fullscreenIconLink"
                  ></v-img>
                  <v-img
                    v-if="extendedMode"
                    class="control-button-image"
                    :src="mainView.exitFullscreenIconLink"
                  ></v-img>
                </button>
              </template>
            </v-tooltip>

            <v-tooltip
              :text="
                mainView.minimizeBtnLabel
                  ? mainView.minimizeBtnLabel
                  : 'Minimize'
              "
              location="bottom"
            >
              <template v-slot:activator="{ props }">
                <button
                  v-bind="props"
                  v-if="!isOnNewWindow"
                  class="minimize"
                  @mouseover="isShowTooltipOnHover ? props : ''"
                  @click="onMinimizeButtonClick()"
                >
                  <v-img
                    class="control-button-image"
                    :src="mainView.minimizeBtnIconLink"
                  ></v-img>
                </button>
              </template>
            </v-tooltip>

            <v-tooltip
              :text="mainView.closeBtnLabel ? mainView.closeBtnLabel : 'Close'"
              location="bottom"
            >
              <template v-slot:activator="{ props }">
                <button
                  v-bind="props"
                  v-if="!isOnNewWindow && widgetData.config.isKioskMode"
                  @mouseover="isShowTooltipOnHover ? props : ''"
                  class="minimize"
                  @click="onCloseBtnClickedKiosk()"
                >
                  <v-img
                    class="control-button-image"
                    :src="mainView.closeBtnIconLink"
                  ></v-img>
                </button>
              </template>
            </v-tooltip>
          </header>
          <v-progress-linear
            v-if="showVideoLoader"
            indeterminate
            color="primary"
          ></v-progress-linear>
          <div
            id="main-alert"
            v-if="
              $store.state.appData.WidgetData.config.errorsDisplayType ==
              'alert'
            "
          >
            <v-alert
              v-for="alert in $store.state.alertsArr"
              :key="alert.id"
              closable
              icon="mdi-alert"
              variant="flat"
              :class="
                alert.text.split(' ')[0]
                  ? alert.text.split(' ')[0].toUpperCase()
                  : '_' + '_' + alert.text.split(' ')[1]
                  ? alert.text.split(' ')[1].toUpperCase()
                  : '_' + '_' + alert.text.split(' ')[2]
                  ? alert.text.split(' ')[2].toUpperCase()
                  : '_' + '_ALERT'
              "
              :type="alert.type"
              style="opacity: 0.8"
              density="default"
              @input="closeAlert(alert.id)"
            >
              <span v-html="getLinkifyText(alert.text)"></span>
            </v-alert>
          </div>
          <div
            ref="logBtn"
            style="
              float: right;
              position: fixed;
              z-index: 100000000;
              top: 200px;
              right: 0px;
            "
          >
            <v-tooltip
              location="bottom"
              z-index="10000000000000000"
              v-if="
                isSaveLogEnabled() && videoView.isShowLogBtn && isShowLogBtn
              "
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  id="save-log-btn"
                  @mouseover="isShowTooltipOnHover ? props : ''"
                  style="
                    background: #4fc1ec;
                    border-color: #4fc1ec;
                    width: 50px;
                    height: 50px;
                  "
                  class="mx-2"
                  icon
                  @click="
                    saveLogClicked();
                    showTooltip('tooltip-showlog');
                  "
                >
                  <v-img
                    style="max-width: 30px"
                    :src="videoView.saveLogIconLink"
                  ></v-img>
                </v-btn>
              </template>
              <span id="tooltip-showlog">
                {{
                  videoView.saveLogLabel ? videoView.saveLogLabel : "Save log"
                }}
              </span>
            </v-tooltip>
          </div>

          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
        <v-btn
          class="maximize"
          v-if="minimized && !isOnNewWindow"
          @click="onMaximizeButtonClick()"
          icon
        >
          <v-img
            v-if="mainView.chatBtnIconLink"
            left
            class="chat-button-icon"
            :src="mainView.chatBtnIconLink"
          ></v-img>
          <v-img
            v-if="!mainView.chatBtnIconLink"
            left
            class="chat-button-icon"
            :src="'./assets/Chat_Button.svg'"
          ></v-img>
        </v-btn>
      </div>
    </div>
  </v-app>
</template>

<script>
import Utils from "../helpers/utils";
import ErrorService from "../services/ErrorService";
import ConversationService from "../services/ConversationService";
import { mapGetters } from "vuex";
import EnterChatView from "./EnterChatView";
import ConversationView from "./ConversationView";
import AfterChatView from "./AfterChatView";
import ErrorsStatusesView from "./ErrorsStatusesView";
import OOHService from "../services/OOHService";
import SchedulingService from "../services/SchedulingService";
import AppService from "../services/AppService";
import VidyoService from "../services/VidyoService";
import ConsoleLogService from "../services/ConsoleLogService";
import linkifyStr from "linkify-string";
import $ from "jquery";
import { watch } from "vue";

export default {
  name: "MainView",
  data() {
    return {
      side: "right",
      minimized: true,
      // events: [],
      chatEventHeader: "[ccspChatEvent]",
      isShowLogBtn: "true",
      conversationService: new ConversationService(),
      canShowWIQMsg: true, //WIQ = Waiting in queue,
      isChatButtonDisabled: false,
      myWindow: null,
      oohObj: {},
      oos: false,
      extendedMode: false,
      loaded: false,
    };
  },
  computed: {
    isAlertDismissable() {
      return !Utils.getCurrentRouteName() === "EnterView";
    },
    isOnNewWindow() {
      return !!document.getElementById("custom-chat-new-window");
    },
    getHeaderDispaly() {
      return this.isOnNewWindow ? "none" : "flex";
    },
    isMobile() {
      return Utils.mobileCheck();
    },
    isShowTooltipOnHover() {
      return (
        (this.isMobile && !this.widgetData.config.disableTooltipOnMobile) ||
        !this.isMobile
      );
    },
    ...mapGetters([
      "redDot",
      "isConnect",
      "widgetData",
      "pollingCounter",
      "appData",
      "alertData",
      "isAgentRespond",
      "isShowErrorsView",
      "oohShowOptions",
      "mainView",
      "conversationView",
      "showVideoLoader",
      "videoMessage",
      "videoView",
      "getWidgetHost",
      "IISAppName",
      "isAgentAvailableCheckingConfigured",
      // ...
    ]),
  },
  mounted() {
    // replace the setTimeout with this.$nextTick to ensure DOM is loaded
    this.$nextTick(() => {
      Utils.log.debug("MainView mounted");
      this.extendedMode = localStorage.getItem("cc_extended") == "true";
      this.displayextendView();
      this.$EventBus.on("minimizeScreen", () => {
        Utils.log.debug("on minimizeScreen root event..");
        if (this.isOnNewWindow) {
          if (!this.inIframe()) {
            Utils.log.info("new window will close..", this.myWindow);
            self.close();
          }
        } else {
          this.onMinimizeButtonClick();
        }
      });
      //listen to getter, in order to show error at view (instead of alert).
      watch(this.isShowErrorsView, (newVal, oldVal) => {
        if (newVal) {
          this.$router.push("ErrorsStatusesView");
        }
      });
      // setTimeout(
      //   (that) => {
      //     that.loaded = true;
      //     // delay to ensure minimized does not flash
      //     Utils.log.debug("MainView loaded set");
      //   },
      //   500,
      //   this
      // );
      this.loaded = true;
      Utils.log.debug("MainView mounted complete");
    });
  },
  methods: {
    getLinkifyText(txt) {
      let options = {
        /* � */
        target: "_blank",
      };
      return linkifyStr(txt, options);
    },
    showTooltip(id) {
      if (
        (!Utils.mobileCheck() && !Utils.isSafari()) ||
        (Utils.mobileCheck() && this.widgetData.config.disableTooltipOnMobile)
      ) {
        return;
      }
      let el = document.querySelector("#" + id);
      if (el) {
        Utils.log.debug("showTooltip: " + id);
        document.querySelector("#" + id).parentElement.style.display = "block";
        document.querySelector("#" + id).parentElement.style.opacity = "0.9";
        setTimeout(() => {
          document.querySelector("#" + id).parentElement.style.display = "none";
        }, 1000);
      }
    },
    isSaveLogEnabled() {
      return ConsoleLogService.isEnabled();
    },
    saveLogClicked() {
      ConsoleLogService.createLogs();
    },
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    checkVersion() {
      var pjson = require("../../package.json");
      if (this.$store.state.appData.Version) {
        if (pjson.version !== this.$store.state.appData.Version) {
          Utils.log.info(
            `JSON version is ${this.$store.state.appData.Version}, and application version is ${pjson.version}. Consider updating the JSON file`
          );
        } else {
          Utils.log.info(
            `JSON version is ${this.$store.state.appData.Version}, and application version is ${pjson.version}. compatible`
          );
        }
      }
    },
    closeAlert(alertId) {
      this.$store.commit("removeAlertFromArray", alertId);
    },
    //swtich view side
    onSwitchSide() {
      let cb = this.$refs.cb;
      //remove style which inserted when div moved with mouse.
      cb.removeAttribute("style");
      this.side = this.side === "right" ? "left" : "right";
      this.setExtendedMode(false);
    },
    setExtendedMode(mode) {
      this.extendedMode = mode;
      localStorage.setItem("cc_extended", mode.toString());
    },
    initMoveDiv() {
      let st = setTimeout(() => {
        //Wait for the wrapped div loaded on DOM when maximize the widget
        Utils.initMoveDiv(this.$refs.cb, this.$refs.checkBoxHeader);
        clearTimeout(st);
      }, 300);
    },
    initMoveLogBtn() {
      let st = setTimeout(() => {
        //Wait for the wrapped div loaded on DOM when maximize the widget
        Utils.initMoveDiv(this.$refs.logBtn, this.$refs.logBtn, true);
        clearTimeout(st);
      }, 300);
    },

    //triggred on joinchat
    async getEventsTimeoutFunction() {
      //only if in conversation view or video
      //triggred once join chat succeeded
      var currRoute = Utils.getCurrentRouteName();
      if (
        !currRoute || // Can be after previous chat had error
        currRoute === "ConversationView" ||
        currRoute === "EnterView" ||
        currRoute === "videoView"
      ) {
        Utils.log.debug("Getting events from " + currRoute);
        await this.conversationService.getEvents(
          this.onChatStatusReceived,
          this.onChatDisconnect
        );
      }
    },
    //Set Waiting in queue message
    getWIQMessage(result) {
      let message = "";
      let status = this.appData.StatusRes[result.Status_Code];
      if (status) {
        message = status.messageForUser;
      }
      let returnedMessage = message.replace(
        "{timeToWait}",
        this.appData["WaitingInQueue"][result.Additional_Information]
      );
      returnedMessage = returnedMessage.replace(
        "{minutesToWait}",
        result.Estimated_Time
      );
      return returnedMessage;
    },
    onChatStatusReceived(result) {
      let message;
      let status = this.appData.StatusRes[result.Status_Code];
      if (status) {
        message = status.messageForUser;
      }

      // Show conversation for not-waiting-for agent events or availability already checked/disabled
      if (
        result.Status_Code != "105" ||
        this.$store.state.availabilityChecked ||
        !this.isAgentAvailableCheckingConfigured
      )
        this.$store.commit("setHideConversation", false);

      //Waiting in queue
      if (result.Status_Code == "165") {
        //Determine if show every "165" status, or only the first.

        switch (true) {
          //show special message once
          case +this.widgetData.config.showWaitingInQueueIndicator === -2:
            if (!this.canShowWIQMsg) {
              return;
            }
            this.canShowWIQMsg = false;
            message = this.widgetData.config.WaitingInQueueNoTIQMessage;
            break;
          //show regular message once
          case +this.widgetData.config.showWaitingInQueueIndicator === -1:
            if (!this.canShowWIQMsg) {
              return;
            }
            this.canShowWIQMsg = false;
            message = this.getWIQMessage(result);
            break;
          //show regular message when its come
          case +this.widgetData.config.showWaitingInQueueIndicator === 0:
            message = this.getWIQMessage(result);
            break;
          //show regular message with interval
          case +this.widgetData.config.showWaitingInQueueIndicator > 0:
            if (this.canShowWIQMsg) {
              message = this.getWIQMessage(result);
              this.conversationService.addSystemMessage(message);
              this.canShowWIQMsg = false;
              clearTimeout(this.currentWIQTimeout);
              let that = this;
              this.currentWIQTimeout = setTimeout(() => {
                that.canShowWIQMsg = true;
              }, +that.widgetData.config.showWaitingInQueueIndicator * 1000);
            }
            return;
        }
      }
      if (result.Status_Code == "166") {
        this.$store.commit("setCallId", result.Call_Id);
        return;
      }
      //Agent Maybe Explicitly disconnected, or by another TP reason.
      if (result.Status_Code == "107") {
        var bypassAlert =
          (this.$store.state.appData.DataGlobal.connId == -1 ||
            !this.$store.state.connectedToCallCenter) &&
          !result.Additional_Information;
        //disconnected by TP. so changing the ConnId paramter to "-1" becuase maybe the connId doesn't updated to "-1".
        this.$store.commit("setConnId", -1);
        this.$store.commit("setConnectedToCallCenter", false);
        if (
          result.Additional_Information == 8 &&
          this.$store.state.availabilityChecked != true &&
          this.isAgentAvailableCheckingConfigured &&
          this.widgetData.queueChecks.interval &&
          this.widgetData.queueChecks.interval > 0 &&
          this.widgetData.queueChecks.maxPolling &&
          this.widgetData.queueChecks.maxPolling > 0
        ) {
          Utils.log.debug(
            "No agents available, availability checking enabled but not done so doing that..."
          );
          // Likely already set from 105 event, but to be sure
          this.$store.commit("setHideConversation", true);
          this.$router.push({
            name: "EnterView",
            params: { doCheckAvailability: true },
          });
          return;
        }
        // reset for retry
        this.$store.state.availabilityChecked = false;
        // Externally controlled CC will not have user disconnect button to react to, so using this
        if (
          this.widgetData.config.externalController == true &&
          this.widgetData.config.isPostSurvey == true &&
          this.isAgentRespond == true
        ) {
          Utils.log.debug(
            "External controller & survey, routing to survey after ensuring Vidyo disconnected"
          );
          VidyoService.disconnectVidyoCall();
          this.$store.commit("setVideoMessage", null);
          this.$router.push("PostSurveyView");
          return;
        }

        //in case we are in middle of video call
        Utils.log.debug("No external controller/survey, routing to chat");
        this.$store.commit("setCurrentView", "chat");

        VidyoService.disconnectVidyoCall();
        this.$store.commit("setVideoMessage", null);
        // this.$store.commit("setTPCAll", true);

        // this.$store.commit("initChatAndVideo");

        let status = this.appData.StatusRes[result.Status_Code];
        if (status) {
          message = status.messageForUser;
        }
        if (result.Additional_Information) {
          message =
            message +
            " Reason: " +
            this.appData["NoAgentForThisCall"][result.Additional_Information];
        }
        //Show alert/error_view only if current view is not AfterView/PostSurveyView.
        if (
          !bypassAlert &&
          Utils.getCurrentRouteName() !== "AfterView" &&
          Utils.getCurrentRouteName() !== "PostSurveyView"
        ) {
          ErrorService.displayAlert(message, "error");
        }
      }
      //Agent Hold
      if (result.Status_Code == "157") {
        this.$store.commit("setCallOnHold", true);
      }
      //Agent Unhold
      if (result.Status_Code == "133") {
        this.$store.commit("setCallOnHold", false);
        this.$EventBus.emit("connectedToCallCenterEvent");
      }

      if (!message) {
        try {
          Utils.log.info("Unknown status received: " + JSON.stringify(result));
        } catch (e) {
          Utils.log.error(e);
        }
        return;
      }
      this.conversationService.addSystemMessage(message);
    },
    //Agent Explicitly disconnected a.k.a "normally disconnect"
    onChatDisconnect(strParticipant) {
      //normally disconnect
      this.$store.commit("setConnId", -1);
      this.$store.commit("setConnectedToCallCenter", false);
      // SC mainly for when disconnected with no agents available etc
      if (strParticipant && strParticipant != '' && strParticipant != 'undefined') {
        this.conversationService.addSystemMessage(
          this.appData.ParticipantDisconnectedMessage.replace(
            "{name}",
            strParticipant
          )
      );
      }
      // if (this.widgetData.config.isKioskMode) return;
      if (this.widgetData.config.isPostSurvey && this.isAgentRespond) {
        Utils.setCurrentRoute("PostSurveyView"); // this.$router.push("PostSurveyView");
      } else {
        Utils.setCurrentRoute("AfterView"); //this.$router.push("AfterView");
      }
    },

    onMinimizeButtonClick() {
      this.minimized = true;
      Utils.log.debug("minimized = true (onMinimizeButtonClick)");
      this.$store.commit("setRedDot", false);
      this.closeAlert();
    },
    async onMaximizeButtonClick() {
      //If openAsNewWindow, open the application at seperate window then tenant site.
      if (this.widgetData.config.openAsNewWindow === true) {
        this.isChatButtonDisabled = true;
        this.myWindow = window.open(
          `${location.protocol}//${this.getWidgetHost}/${this.IISAppName}/openedwindow.html?protocol=${location.protocol}&widgetHost=${this.getWidgetHost}&helperapi=${this.$store.state.helperApiAppName}&IISAppName=${this.IISAppName}&newWindowTitle=${this.widgetData.config.newWindowTitle}&dataFileUrl=${this.$store.state.dataFileUrl}`,
          "_blank",
          this.widgetData.config.newWindowConfig
        );
        //Check if new window closed
        let timer = setInterval(() => {
          if (this.myWindow.closed) {
            clearInterval(timer);
            this.isChatButtonDisabled = false;
          }
        }, 1000);
      } else {
        this.$EventBus.emit("maximizeClicked");
        this.minimized = false;
        Utils.log.debug("minimized = false (onMaximizeButtonClick)");
        //disappear "red dot" when maximize
        this.$store.commit("setRedDot", false);

        //we want to set it only on regular mode, not new window
        this.initMoveDiv();
      }

      //check OOH only when kiosk is closed
      if (
        this.widgetData.config.isKioskMode &&
        this.$store.state.kioskIsClose
      ) {
        this.$store.commit("setKioskIsClose", false);

        let scheduling = new SchedulingService();
        this.oos = scheduling.isOOSShowing();
        if (this.oos === true) {
          var obj = { oos: this.oos, message: "OOS" };
          return obj;
        }

        try {
          let ooh = new OOHService();
          this.oohObj = await ooh.getOperatingStatus();
          if (this.oohObj.is_open == undefined) {
            Utils.log.error("Error with got OOH data");
            return;
          }
          this.$store.commit("setOohData", this.oohObj);
          if (this.oohObj.is_open == false)
            Utils.log.debug("OOH Show Options = " + this.oohShowOptions);

          //no need to show button and anything
          if (this.oohObj.is_open == false && this.oohShowOptions == "hide") {
            return;
          }

          if (this.oohObj.is_open == false) {
            //avoid redundent route
            if (
              this.$store.getters.isCallbackPossibleDefault &&
              this.oohShowOptions == "callback"
            ) {
              Utils.log.debug("OOH Callback");
              this.$store.commit("setForceCallback", {
                forced: true,
                message: this.oohObj.message,
              }); // Enterview set below
            } else if (this.oohShowOptions == "view") {
              Utils.log.debug("OOH View");
              if (
                Utils.getCurrentRouteName() == null ||
                (Utils.getCurrentRouteName() &&
                  Utils.getCurrentRouteName().toUpperCase() !== "OOHVIEW")
              ) {
                this.$router.push("oohView");
              }
              return;
            }
          }

          //finally, if not out of hours
          var defaultRoute = "EnterView";
          if (
            this.$store.getters.initialRoute &&
            this.$store.getters.initialRoute !== ""
          )
            defaultRoute = this.$store.getters.initialRoute;
          if (
            Utils.getCurrentRouteName() === null ||
            (Utils.getCurrentRouteName() &&
              Utils.getCurrentRouteName().toUpperCase() !==
                defaultRoute.toUpperCase())
          ) {
            Utils.log.debug("come to router.push to " + defaultRoute + " ..");
            this.$router.push(defaultRoute);
          }
        } catch (e) {
          Utils.log.error(e);
          return;
        }
      }
    },
    async prepareAppData() {
      try {
        Utils.log.debug("MainView prepareAppData");
        // At this stage we do not know if externally controlled
        window.parent.postMessage(
          { CC: { initStatus: "started", isPostSurvey: false } },
          "*"
        );

        let filesArr = await this.$store.dispatch("getAppData");
        var dataGlobalStr = sessionStorage.getItem("cc_resumed");
        Utils.log.debug(
          $`MainView prepareAppData isConnect=${this.isConnect}, cc_resumed=${dataGlobalStr}`
        );
        var dataGlobal = dataGlobalStr ? JSON.parse(dataGlobalStr) : null;
        if (dataGlobal && dataGlobal.connId) {
          if (!this.isConnect) {
            Utils.log.debug(
              `MainView prepareAppData Restoring resumed connection ID ${dataGlobal.connId} and last event ID ${dataGlobal.lastEventId}`
            );
            this.$store.state.appData.DataGlobal.connId = dataGlobal.connId;
            this.$store.state.appData.DataGlobal.lastEventId =
              dataGlobal.lastEventId;
            this.getEventsTimeoutFunction();
          }

          Utils.log.debug(
            "MainView prepareAppData Resumed call only preparing CSS + JS then triggering polling"
          );
          this.setAppCss();
          this.setConfiguredCss(
            Utils.findObJInArrByKeyValue(filesArr, "fileName", "style.css").text
          );
          //get myscript.js
          let myscript = Utils.findObJInArrByKeyValue(
            filesArr,
            "fileName",
            "myscript.js"
          );
          if (myscript && myscript.text) {
            Utils.log.info(
              "MainView prepareAppData Resumed call myscript.js was found.."
            );
            this.setConfiguredJS(myscript.text);
          }
          this.$EventBus.emit("appDataLoaded");
          return;
        } else {
          Utils.log.debug("MainView prepareAppData Non-resumed call");
        }
        let scheduling = new SchedulingService();
        this.oos = scheduling.isOOSShowing();
        if (this.oos === true) {
          var obj = { oos: this.oos, message: "OOS" };
          throw obj;
        }

        let ooh = new OOHService();
        this.oohObj = await ooh.getOperatingStatus();
        if (this.oohObj.is_open == undefined) {
          Utils.log.error("MainView prepareAppData Error with got OOH data");
          throw this.oohObj;
        }
        this.$store.commit("setOohData", this.oohObj);
        if (this.oohObj.is_open == false)
          Utils.log.debug(
            "MainView prepareAppData OOH Show Options = " + this.oohShowOptions
          );

        //no need to show button and anything
        if (this.oohObj.is_open == false && this.oohShowOptions == "hide") {
          throw this.oohObj;
        }

        //need to load style here, in order to show the ooh view properly
        this.setAppCss();
        this.setConfiguredCss(
          Utils.findObJInArrByKeyValue(filesArr, "fileName", "style.css").text
        );
        
        //get myscript.js
        let myscript = Utils.findObJInArrByKeyValue(
          filesArr,
          "fileName",
          "myscript.js"
        );
        if (myscript && myscript.text) {
          Utils.log.info("MainView prepareAppData myscript.js was found..");
          this.setConfiguredJS(myscript.text);
        }

        if (this.oohObj.is_open == false) {
          if (
            this.$store.getters.isCallbackPossibleDefault &&
            this.oohShowOptions == "callback"
          ) {
            Utils.log.debug("MainView prepareAppData OOH Callback");
            this.$store.commit("setForceCallback", {
              forced: true,
              message: this.oohObj.message,
            });
          } else if (
            this.oohObj.is_open == false &&
            this.oohShowOptions == "view"
          ) {
            this.$router.push("oohView");
            throw this.oohObj;
          }
        }
        // We're going to normal handling - enable console capture if configured
        ConsoleLogService.readConfig();
        this.$EventBus.emit("appDataLoaded");
        if (this.$store.getters.widgetData.config.externalController == true)
          window.parent.postMessage(
            {
              CC: {
                initStatus: "succeeded",
                isPostSurvey:
                  this.$store.getters.widgetData.config.isPostSurvey,
              },
            },
            "*"
          );
        if (
          navigator.geolocation &&
          this.$store.getters.widgetData.config.location
        ) {
          Utils.log.info("Trying to get Geo Location");
          const geosuccessCallback = (position) => {
            Utils.log.info("Got Geo Location", position);
            if (position.coords) {
              var url = this.$store.getters.widgetData.config.location
                .replace("{accuracy}", position.coords.accuracy)
                .replace("{latitude}", position.coords.latitude)
                .replace("{longitude}", position.coords.longitude)
                .replace("{altitude}", position.coords.altitude)
                .replace("{altitudeAccuracy}", position.coords.altitudeAccuracy)
                .replace("{heading}", position.coords.heading)
                .replace("{speed}", position.coords.speed);

              this.$store.commit("setLocation", url);
            }
          };
          const geoerrorCallback = (error) => {
            Utils.log.warn("Failed trying to get Geo Location", error);
          };
          navigator.geolocation.getCurrentPosition(
            geosuccessCallback,
            geoerrorCallback
          );
        }
      } catch (e) {
        Utils.log.info(
          "MainView prepareAppData Out Of Hours Or GetAppData Error",
          e
        );
        Utils.postMessageObject("status", "Out Of Hours Or GetAppData Error");
        // OOH failure is a successful init
        if (
          e != this.oohObj ||
          !this.$store.getters.widgetData ||
          !this.$store.getters.widgetData.config
        )
          window.parent.postMessage(
            { CC: { initStatus: "failed", isPostSurvey: false } },
            "*"
          );
        else if (
          this.$store.getters.widgetData.config.externalController == true
        )
          window.parent.postMessage(
            { CC: { initStatus: "succeeded", isPostSurvey: false } },
            "*"
          );
        this.$EventBus.emit("appDataLoaded");
        throw e;
      }
    },
    displayextendView() {
      if (!this.$refs.cb) return;
      if (!this.extendedMode) {
        this.$refs.cb.style.width = "20%";
        this.$refs.cb.style.right = this.viewPosition.right;
        this.$refs.cb.style.left = this.viewPosition.left;
      } else {
        this.viewPosition.left = this.$refs.cb.style.left;
        this.viewPosition.right = this.$refs.cb.style.right;

        this.$refs.cb.style.left = "0px";
        this.$refs.cb.style.maxWidth = "100000px";
        this.$refs.cb.style.width = "100%";
      }
    },
    extendView() {
      this.setExtendedMode(!this.extendedMode);
      this.displayextendView();
    },
    //Insert configured CSS file into Tenant Site
    setConfiguredCss(styles) {
      /* Create style document */
      if (document.getElementById("ccMVcss"))
        document.getElementById("ccMVcss").remove();
      let css = document.createElement("style");
      css.id = "ccMVcss";
      css.type = "text/css";

      //TODO: check the logic here
      if (css.styleSheet) {
        css.styleSheet.cssText = styles;
      } else {
        css.appendChild(document.createTextNode(styles));
      }

      /* Append style to the tag name */
      document.getElementsByTagName("head")[0].appendChild(css);
    },
    //Insert configured JS file into Tenant Site
    setConfiguredJS(js) {
      /* Create style document */
      if (document.getElementById("ccMVjs"))
        document.getElementById("ccMVjs").remove();
      let myscript = document.createElement("script");
      myscript.type = "text/javascript";
      myscript.id = "ccMVjs";

      //TODO: check the logic here
      myscript.innerHTML = js;

      /* Append style to the tag name */
      document.getElementsByTagName("head")[0].appendChild(myscript);
    },

    //Insert application const CSS file into Tenant Site
    setAppCss() {
      //determine if on test page or an a tenant site
      let onCusomChatPage = document.getElementById("customchat-test-page");
      let isUseAppCss = !(this.widgetData.config.isUseAppCss !== undefined && this.widgetData.config.isUseAppCss == false);
      if (!onCusomChatPage && isUseAppCss) {
        if (document.getElementById("ccMVAppcss"))
          document.getElementById("ccMVAppcss").remove();
        let file = document.createElement("link");
        file.rel = "stylesheet";
        file.id = "ccMVAppcss";
        file.href = "/PS.CustomChat/css/app.css";
        file.type = "text/css";

        document.body.appendChild(file);
      }
    },

    onCloseBtnClickedKiosk() {
      Utils.postMessageObject("status", "Contact disconnected by consumer");
      this.$store.dispatch("leaveChat", { isAsync: true });
      this.$store.commit("setConnectedToCallCenter", false);
      this.$store.commit("setKioskIsClose", true);
      this.$store.commit("initChatAndVideo");
      this.$EventBus.emit("minimizeScreen");
      this.$store.commit("resetConversationData");
      this.$router.push("AfterView");

      VidyoService.disconnectVidyoCall();
    },
    isSaveLogEnabled() {
      return ConsoleLogService.isEnabled();
    },
  },
  async created() {
    Utils.log.debug("MainView created");
    this.viewPosition = {};
    try {
      await this.prepareAppData();
      if (sessionStorage.getItem("cc_resumed")) {
        var curRoute = Utils.getCurrentRouteName();
        Utils.log.debug(
          "Polling resumption mode - checking current route " + curRoute
        );
        if (
          curRoute == null ||
          (curRoute && curRoute.toUpperCase() == "EnterView".toUpperCase())
        ) {
          this.$EventBus.emit("maximizeClicked");
          this.minimized = false;
          // In case launched in IFrame and need to tell to resume with opened panel
          window.parent.postMessage({ CC: { show: true } }, "*");
          //we want to set it only on regular mode, not new window
          this.initMoveDiv();
        } else {
          this.$router.push("ConversationView");
        }
      } else {
        if (this.widgetData.config.externalController == true)
          Utils.listenForMessages(); // Allow control from Watson etc.
        if (
          this.isAgentAvailableCheckingConfigured &&
          this.widgetData.queueChecks.noAgent_Hide
        ) {
          var available = await this.$store.dispatch("isAgentAvailable");
          if (!available) {
            Utils.log.debug("Removing as no agents available");
            //$( "custom-chat" ).remove();
            $("custom-chat").addClass("NoAgentsAvailable");
            return;
          }
        }

        //   //only on the open window when the mode is "open as new window", or the regular - on internal div
        if (this.widgetData.config.isKioskMode || this.isOnNewWindow) {
          this.extendView();
        }
        //in order to aviod duplicate routing, so we check if current view already "enterView" (or passed route parameter)
        console.log("this.$router.currentRoute", this.$router.currentRoute);
        var defaultRoute = "EnterView";
        if (
          this.$store.getters.initialRoute &&
          this.$store.getters.initialRoute !== ""
        )
          defaultRoute = this.$store.getters.initialRoute;
        if (
          Utils.getCurrentRouteName() == null ||
          (Utils.getCurrentRouteName() &&
            Utils.getCurrentRouteName().toUpperCase() !==
              defaultRoute.toUpperCase())
        ) {
          Utils.log.debug("come to router.push to " + defaultRoute + ".. ");
          this.$router.push(defaultRoute);
        }
      }
      this.checkVersion();
      if (
        this.widgetData.config.videoVendor &&
        this.widgetData.config.videoVendor !== "" &&
        this.widgetData.config.isKioskMode == false
      ) {
        VidyoService.init();
      }
    } catch (err) {
      if (err) {
        Utils.log.error(err.message);
      }
      if (err == this.oohObj && this.isOnNewWindow) {
        this.minimized = false;
        Utils.log.debug("minimized = false (created ooh)");
        return;
      }
      throw err;
    }

    //if opened at new window
    if (this.isOnNewWindow) {
      this.minimized = false;
      Utils.log.debug("minimized = false (created isOnNewWindow)");
    }
    // listen for event when it fired from each view.
    this.$EventBus.on("handleRestartButtonClick", () => {
      // on Restart - get the clean json and css
      this.$store.commit("initChatAndVideo");
      this.canShowWIQMsg = true;
      this.closeAlert();
      if (this.$router.currentRoute)
        this.$router.currentRoute.name = "EnterView"; // After surveys it was not immediately changed with subsequent push and prevented chat polling
      this.$router.push("/");
      window.location.replace;
    });

    this.$EventBus.on("onJoinChat", () => {
      this.getEventsTimeoutFunction();
    });
  },
  destroyed() {
    clearTimeout(this.getEventTimeOut);
    window.removeEventListener("unload", this.unloadCallback);
    window.onbeforeunload = null;
  },
};
</script>

<style scoped>
/* URlS for Materials Icons */
/* @import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"); */
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css");

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

#main-alert {
  z-index: 10000000;
  position: absolute;
  top: 44px;
  left: 0;
  width: 100%;
}

@font-face {
  font-family: UniNeueLight;
  src: url("../assets/UniNeue-Light.otf") format("opentype");
}
@font-face {
  font-family: UniNeueHeavyItalic;
  src: url("../assets/UniNeue-HeavyItalic.otf") format("opentype");
}
.control-button-image {
  max-width: 25px;
}
.chat-button-icon {
  position: unset;
}
</style>
